var map = {
	"./burst fade.jpg": 7238,
	"./buzzcut.jpg": 209,
	"./formacije.jpg": 8828,
	"./formacije_naslovna.jpg": 6359,
	"./fund_unutra.jpg": 7101,
	"./fundamental.jpg": 7433,
	"./fundamentalne.jpg": 8250,
	"./hands_on.jpg": 2776,
	"./jednodnevne.jpg": 7116,
	"./kreativ_nova.jpg": 1077,
	"./kreativna_formacija.jpg": 4340,
	"./look_and_learn.jpg": 8674,
	"./low fade.jpg": 7986,
	"./mid fade.jpg": 1126,
	"./mullet.jpg": 5879,
	"./novi_fade_unutra_1.jpg": 6333,
	"./novi_fade_unutra_2.jpg": 2178,
	"./one_on_one.jpg": 8387,
	"./pocetnicke.jpg": 8899,
	"./sth_1.jpg": 1099,
	"./sth_2.jpg": 5932,
	"./sth_3.jpg": 3929,
	"./sth_4.jpg": 8186,
	"./taper fade.jpg": 1450,
	"./taper_fade.jpg": 9149,
	"./taper_fade_2.jpg": 3354,
	"./visednevne.jpg": 2557,
	"./wolf cut.jpg": 6506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4469;